<template>
  <div class="height-100">
    <div v-if="!status">
      <v-row class="align-center d-flex row-back-height">
        <h3 class=" ml-3 color-white">
          {{ "현장명 : " + orderInvoiceList.constructionName }}
        </h3>
      </v-row>
      <v-row class="ma-0 pa-0 pt-5">
        <v-spacer />
        <v-btn
          class="mr-5  color-white"
          rounded
          color="#6C98EB"
          @click="
            $router.push({
              name: 'ChoiceCon',
              params: { constId: orderInvoiceList.constructionId },
            })
          "
        >
          홈으로 이동
        </v-btn>
        <v-btn
          class="mr-5  color-white"
          rounded
          color="#6C98EB"
          @click="$router.push({ name: 'Login' })"
        >
          현장선택으로 이동
        </v-btn>
      </v-row>
      <v-simple-table class="ma-5 text-center" v-if="windowWidth >= 1000">
        <thead>
          <tr>
            <th
              class="text-center back-556C96 color-white border-right-white"
              rowspan="2"
            >
              출고차수
            </th>
            <th
              class="text-center back-556C96 color-white border-right-white"
              rowspan="2"
            >
              부위
            </th>
            <th
              class="text-center back-556C96 color-white border-right-white"
              :colspan="materialLists.length"
            >
              규격(단위:TON)
            </th>
            <th
              class="text-center back-556C96 color-white border-right-white"
              rowspan="2"
            >
              소 계
            </th>
          </tr>
          <tr>
            <th
              v-for="material in materialLists"
              :key="material.rebar_id"
              class="text-center back-556C96 border-right-white border-top-white color-white"
            >
              {{ material.rebar_name }}
            </th>
          </tr>
          <tr v-if="statuss && windowWidth > 1000">
            <th class="border-left-aaaaaa border-right-aaaaaa"></th>
            <th class=" border-right-aaaaaa text-center">출고총계</th>
            <th
              v-for="(material, index) in sumList"
              :key="index"
              class="text-center border-right-aaaaaa"
            >
              {{ material }}
            </th>
            <th class="text-center border-right-aaaaaa">{{ sum(sumList) }}</th>
          </tr>
        </thead>
        <tbody v-if="orderInvoiceList">
          <tr v-for="row in orderInvoiceList.rows" :key="row.partName">
            <td class="text-center border-left-aaaaaa border-bottom-aaaaaa">
              {{ row.orderName }}
            </td>
            <td class="text-center border-left-aaaaaa border-bottom-aaaaaa">
              {{ row.partName }}
            </td>
            <td
              v-for="(col, i) in row.rebarList"
              :key="i"
              class="text-center border-left-aaaaaa border-bottom-aaaaaa"
            >
              {{ mathRound(col) }}
            </td>
            <td
              class="text-center border-left-aaaaaa border-bottom-aaaaaa border-right-aaaaaa"
            >
              {{ sum(row.rebarList) }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-simple-table
        class="ma-5 text-center"
        v-if="orderInvoiceList && windowWidth < 1000"
      >
        <tbody
          v-for="(row, i) in orderInvoiceList.rows"
          :key="row.partName"
          class="pa-2 ma-2"
        >
          <tr>
            <td class="text-center back-556C96 color-white ">출고차수</td>
            <td class="text-center  border-bottom-aaaaaa">
              {{ row.orderName }}
            </td>
          </tr>
          <tr>
            <td class="text-center back-556C96 color-white border-top-white">
              부위
            </td>
            <td class="text-center  border-bottom-aaaaaa">
              {{ row.partName }}
            </td>
          </tr>
          <tr v-for="index in materialLists.length" :key="index">
            <td class="text-center back-556C96  border-top-white color-white">
              {{ materialLists[index - 1].rebar_name }}
            </td>
            <td class="text-center border-bottom-aaaaaa">
              {{ mathRound(orderInvoiceList.rows[i].rebarList[index - 1]) }}
            </td>
          </tr>
          <tr>
            <td class="text-center back-556C96 color-white border-top-white">
              소 계
            </td>
            <td class="text-center border-bottom-aaaaaa">
              {{ sum(row.rebarList) }}
            </td>
          </tr>
          <tr>
            <td
              class="text-center back-556C96 color-white border-top-white"
              :style="
                i != orderInvoiceList.rows.length - 1
                  ? 'border-bottom:2px solid black'
                  : ''
              "
            >
              출고여부
            </td>
            <td
              class="text-center   "
              :style="
                i != orderInvoiceList.rows.length - 1
                  ? 'border-bottom:2px solid black'
                  : 'border-bottom:thin solid #aaaaaa'
              "
            >
              {{ orderInvoiceList.completion == "Y" ? "입고완료" : "출고완료" }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-row class="justify-end ">
        <v-btn
          class="back-556C96 color-white mb-2 mr-3"
          rounded
          color="#556C96"
          @click="orderProcess"
          v-if="orderInvoiceList.completion == 'N'"
          >입고처리</v-btn
        >
        <h3 v-else class="mb-2 mr-3">입고처리가 완료된 차수입니다.</h3>
      </v-row>
    </div>
  </div>
</template>

<script>
import UserApi from "@/api/UserService";
import InvoiceApi from "@/api/InvoiceService";
import RebarList from "@/api/RebarService";
import Commonality from "@/mixin/Commonality";
import Mobile from "@/mixin/Mobile";

export default {
  mixins: [Commonality, Mobile],

  props: ["qrText"],

  created() {
    this.urlName = { urlString: document.location.href.split("qrText=")[1] };
    this.checkInvoiceQr();
  },

  data: () => ({
    materialLists: [],
    orderInvoiceList: [],
    tempData: [],
    delimiter: "",
    urlName: "",
    status: false,
    autoLogin: true,
    id: "",
    password: "",
    statuss: false,
  }),

  methods: {
    async login() {
      let data = {
        accountName: this.id,
        accountPassword: this.password,
        autoLogin: this.autoLogin,
      };
      let returnData = await UserApi.userLogin(data);
      if (returnData.data.success == "fail") {
        this.password = "";
        this.$bus.$emit(
          "dialog",
          "로그인에 실패하셨습니다. 다시 시도해주세요."
        );
      } else {
        let data = await UserApi.userInformaion({
          userId: returnData.data.user.userId,
        });
        this.$store.commit("userListChange", data.data.userInformation);
        this.checkInvoiceQr();
      }
    },

    async checkInvoiceQr() {
      let returnData = await InvoiceApi.invoiceQr(this.urlName);
      if (returnData.data.success == "fail") {
        this.$bus.$emit("dialog", "조회된 데이터가 없습니다.");
        this.$router.push({ name: "ChoiceCon" });
        return;
      } else if (
        returnData.data.reason == "현장 및 유저 권한 없음 확인됨" ||
        returnData.data.reason == "출고 목록이 존재하지 않습니다."
      ) {
        this.$bus.$emit("dialog", returnData.data.reason);
        this.$router.push({ name: "ChoiceCon" });
        return;
      }
      this.delimiter = returnData.data.delimiter;
      this.tempData = returnData.data;
      this.orderInvoiceList = returnData.data.invoiceDetail;
      let returnMaterial = await RebarList.rebarList({
        constructionId: this.orderInvoiceList.constructionId,
      });
      this.materialLists = returnMaterial.data.RebarList;
      this.status = false;
      this.sumLists();
    },

    async orderProcess() {
      let data = { invoiceId: this.orderInvoiceList.invoiceId };
      let returnData = await InvoiceApi.invoiceComplete(data);
      if (returnData.data.success == "ok") {
        this.$bus.$emit(
          "dialog",
          "입고처리가 완료 되었습니다. 현장으로 이동합니다."
        );
        this.$router.push({
          name: "ChoiceCon",
          params: { constId: this.orderInvoiceList.constructionId },
        });
      }
    },

    sumLists() {
      let list = [];
      for (let i = 0; i < this.orderInvoiceList.rows.length; i++) {
        for (
          let j = 0;
          j < this.orderInvoiceList.rows[i].rebarList.length;
          j++
        ) {
          if (i == 0)
            list[j] = Number(this.orderInvoiceList.rows[i].rebarList[j]);
          else list[j] += Number(this.orderInvoiceList.rows[i].rebarList[j]);
        }
      }
      this.sumList = list;
      this.statuss = true;
    },
  },
};
</script>

<style scoped>
.row-back-height {
  background: #24344b;
  height: 48px;
}
.v-data-table {
  overflow-y: hidden !important;
}

.border-right-000 {
  border-right: thin solid rgba(0, 0, 0, 0.12) !important;
}
.border-bottom-000 {
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}
.border-left-000 {
  border-left: thin solid rgba(0, 0, 0, 0.12) !important;
}

.card {
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0px 4px 4px rgba(35, 62, 111, 0.3);
  border-radius: 15px;
  z-index: 1;
}

.pa-40 {
  padding: 40px;
}

.btn {
  color: white !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

h2 {
  color: white;
}

.width-height {
  width: 100%;
  height: 100%;
}

.row {
  margin: 0px !important;
}

.input {
  width: 336px;
  height: 46px;
  border-radius: 0px;
  border: 1px solid #ffffff33;
  padding-left: 12px;
  color: white;
}

.login-Btn {
  height: 62px !important;
  background: #68bae8 !important;
  color: white !important;
  font-style: Bold;
  font-size: 18px !important;
  border-radius: 100px !important;
  left: 0px;
  top: 0px;
}

.login {
  background-image: url(../../assets/login/login.svg);
  top: 0;
  left: 0;
  position: absolute;
  background-size: 100%;
  content: "";
  width: 100%;
  height: 100%;
}

.login-more {
  top: 0;
  left: 0;
  position: absolute;
  background-size: 100%;
  opacity: 0.8;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #1e3c72 0%, #2a5298 100%),
    linear-gradient(0deg, #ffffff, #ffffff);
}

.login {
  height: 100%;
  position: relative;
  z-index: 1;
  border-radius: 30px !important;
}

.input::placeholder {
  color: white;
}
</style>
